import { Button, Card, Container, Flex, Grid, Modal, Stack,Text,Center,Checkbox,Title,Table,Paper } from '@mantine/core'
import { useForm } from '@mantine/form';
import { useDisclosure } from '@mantine/hooks'
import actionsIndex from "../forms/components/actions.json"
import React from 'react'
import { addAction } from '../connections/requests';

export default function ActionTabs({actions,memberID}) {
  const [modal,{toggle}] = useDisclosure(false);
  return (
    <Container>
      <Modal
        opened={modal}
        memberID
        onClose={()=> toggle()}
        size={"80%"}
      >
        <ActionModal memberID={memberID} actionsMember={actions}/>
      </Modal>
      <Button onClick={()=>toggle()}>Ajouter Actions</Button>
      <div>Liste des actions</div>
      <Stack>
        <Card>
          <Card.Section>
            <Text ta={"center"}>Actions</Text>

          </Card.Section>
          <Card.Section p={"md"}>
            {actions ? Object.keys(actions).map(e => <CardBody index={e}/>): null}
          </Card.Section>
        </Card>
      </Stack>
    </Container>
  )

  function CardBody({index}){
    return(
      <Card gap={"lg"}>
        <Grid>
          <Grid.Col span={3}>
            <Text children={actionsIndex[index].action} />
          </Grid.Col>
          <Grid.Col span={6}>
            <Text children={actionsIndex[index].description}/>
          </Grid.Col>
          <Grid.Col span={2}>
              <Center h={"100%"}>
                <Button>Completer</Button>
              
              </Center>
          </Grid.Col>
        </Grid>
      </Card>
    )
  }
}
function ActionModal({memberID,actionsMember}){
  const form = useForm({initialValues:{_id:memberID,actions:actionsMember}});

  return <>
                  <Card>
                  <Card.Section my={"lg"} p={"md"} bg={"blue"}>
                  <Title ta={"center"} c={"white"}>Actions</Title>
                  </Card.Section>
                  <Paper>
                      <Table>
                      <thead>
                          <th>
  
                          </th>
                          <th>
                              Role de l'intervenant
                          </th>
                          <th>
                              Description de l'action
                          </th>
                      </thead>
                      <tbody>
                              {actionsIndex.map((g,index) => <ActionRow index={index} keys={g.action} {...g} form={form}/>)}
                      </tbody>
                      </Table>
                  </Paper>
                  </Card>
                  <Button onClick={()=>addAction(form)}>Modifier</Button>
  </>


}
function ActionRow(props){
    const {title,role,completion,description,value,onChange,form,index} = props
    return(
            <tr >
                <td >
                    <Center style={{ width: "100%", height: "100%" }} >
                        <Checkbox value={value} onChange={onChange} label={title} {...form.getInputProps(`actions.${index}`,{type:"checkbox"})} />
                    </Center>
                </td>
                <td >
                    <Text>{(role || "") +" "+(completion || " ")}</Text>
                </td>
                <td >
                    <Text>{description}</Text>
                </td>
            </tr>
        )
}
